// extracted by mini-css-extract-plugin
export default {"cls1":"kXJ2cMsWI0RnCQlcB9N8","cls2":"lH_2ecofp7QZ1CEWetkp kXJ2cMsWI0RnCQlcB9N8"};